import { BaseModel } from "./base";
import SituacaoVeiculo from './situacaoVeiculo';

export default class Uf extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public sigla: string,
    public createdAt?: Date,
    public updatedAt?: Date,
  ) {
    super(id);
  }
}
